import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';

export const InteriorLayout = () => <div className="interior-site" data-testid="interior-site">
  <a className="skip-content" href="#main-content" data-testid="skip-content">Skip to content</a>
  <SiteHeader />
  <main id="main-content" tabIndex={-1} data-testid="interior-main"><Outlet /></main>
</div>;